import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DynamicModalLoaderService } from '../../../layout/services/dynamic-modal-loader.service';
import { BasicModalComponent } from '../../../layout/components/modals/basic-modal/basic-modal.component';

@Component({
  selector: 'gen-therapy-title-element',
  templateUrl: './therapy-title-element.component.html',
  styleUrls: ['./therapy-title-element.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class TherapyTitleElementComponent implements OnInit {
  @Input() subTitle: string;
  @Input() icon: string;
  @Input() value: string;
  @Input() classes: string;
  @Input() modalData: string;
  @Input() modalTitle: string;

  public showTooltip: boolean;

  constructor(private ModalLoader: DynamicModalLoaderService) {
  }

  loadModal(event) {
    event.stopPropagation();
    event.preventDefault();
    if (this.modalData || this.modalTitle) {
      this.ModalLoader.popupModal(BasicModalComponent, { title: this.modalTitle, content: this.modalData});
    }
  }

  ngOnInit() {
  }

}
